import { useQuery } from '@tanstack/react-query';
import { Link } from '@/components/Link';
import { Band } from '../components/editorial/Band';
import { PageHeader } from '../components/editorial/PageHeader';
import { Eyebrow } from '../components/Eyebrow';
import { catalogQueryOptions } from '../features/catalog/queries';
import { sellersQueryOptions } from '../features/sellers/queries';
import { MARKETPLACE_SELLERS } from '../lib/subprocessors';
import { SellerList } from './sellers/SellerList';

const PROSE =
  'space-y-3 text-15 leading-relaxed text-text-2 [&_a]:text-accent [&_a]:underline [&_a]:underline-offset-2';

/** The public list of marketplace sellers that the Privacy Policy and the Data
 *  Processing Addendum point to. It names every seller AnyAPI has approved and
 *  the endpoints each one serves; a seller still on trial before approval, and
 *  AnyAPI's own sources, are not listed. */
export const SellersPage = () => {
  const sellers = useQuery(sellersQueryOptions()).data;
  const catalog = useQuery(catalogQueryOptions()).data ?? [];
  return (
    <>
      <PageHeader
        eyebrow={<Eyebrow>Legal</Eyebrow>}
        title="Marketplace sellers"
        lede="The independent businesses that can fulfill requests made through AnyAPI."
      />
      <Band>
        <div className="band max-w-190">
          <div className={PROSE}>
            <p>
              Some endpoints can be served by marketplace sellers as well as by AnyAPI. A seller
              that fulfills a request, or is tested on a copy of one before it may fulfill
              requests, receives the parameters needed to answer it. This page lists every seller
              AnyAPI has approved, with the endpoints it serves; a seller that chose to be anonymous
              appears under the name AnyAPI assigns it. A seller still being tested on copies of
              requests, before approval, is not listed. Every seller is bound by the data-handling obligations in the{' '}
              <Link to={MARKETPLACE_SELLERS.terms}>Seller Terms</Link>, and our{' '}
              <Link to="/dpa">Data Processing Addendum</Link> covers them as sub-processors.
            </p>
            <p>
              If you do not want your requests fulfilled by sellers, turn on{' '}
              <strong>{MARKETPLACE_SELLERS.optOutLabel}</strong> on your dashboard{' '}
              <Link to={MARKETPLACE_SELLERS.optOut}>Billing</Link> page.
            </p>
          </div>
          <SellerList sellers={sellers} catalog={catalog} />
        </div>
      </Band>
    </>
  );
};
